<section class="team-form-page">
  <header class="form-header">
    <a class="back-link" routerLink="/dashboard/championship">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      <span>К списку чемпионатов</span>
    </a>
    <h1>{{ title }}</h1>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="team-form" (ngSubmit)="saveChampionship()">
    <section class="form-card">
      <h2>Данные чемпионата</h2>
      <div class="form-grid">
        <label>
          <span>Название чемпионата</span>
          <input class="form-control" name="name" placeholder="КХЛ" [(ngModel)]="formData.name" required>
        </label>
        <label>
          <span>Slug</span>
          <input class="form-control" name="slug" placeholder="khl" [(ngModel)]="formData.slug" required>
        </label>
        <label class="logo-field">
          <span>Логотип</span>
          <input class="form-control" type="file" accept="image/png,image/jpeg,image/webp,image/gif" (change)="selectLogoFile($event)">
          <small>{{ selectedLogoFileName || 'PNG, JPG, WEBP или GIF до 2 МБ' }}</small>
        </label>
        <label>
          <span>Сайт</span>
          <input class="form-control" type="url" name="websiteUrl" [(ngModel)]="formData.websiteUrl">
        </label>
        <label>
          <span>Telegram</span>
          <input class="form-control" type="url" name="telegramUrl" [(ngModel)]="formData.telegramUrl">
        </label>
        <label>
          <span>ВКонтакте</span>
          <input class="form-control" type="url" name="vkUrl" [(ngModel)]="formData.vkUrl">
        </label>
      </div>
    </section>

    <aside class="form-card actions-card">
      <button class="save-button" type="submit" [disabled]="saving || !formData.slug">{{ saving ? 'Сохраняем...' : mode === 'edit' ? 'Сохранить' : 'Создать чемпионат' }}</button>
      <a class="cancel-link" routerLink="/dashboard/championship">Отмена</a>
    </aside>
  </form>
</section>
